import React, { useState } from 'react';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Alert, Button, Snackbar, Dialog, DialogTitle, DialogContent, Typography, DialogActions } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { LoadingButton } from '@mui/lab';
import { BrandEmail } from 'API/Branding';

const WithoutCsp = (props) => {
  const WithouCspBrand = props.WithouCspBrand;
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [DialogData, setDialogData] = useState(null);
  const [Success, setSuccess] = useState(false);
  const [Error, setError] = useState(false);

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'csp_id',
      headerName: 'Application ID',
      width: 120,
      renderCell: (params) => <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>{params.value}</div>,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'agent_name',
      headerName: 'CSP name',
      type: 'number',
      width: 150,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'agent_code',
      headerName: 'Agent Code',
      type: 'number',
      width: 120,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'bank_name',
      headerName: 'Bank Name',
      width: 120,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'csp_code',
      headerName: 'CSP Code',
      type: 'number',
      width: 100,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'csp_code_activation_date',
      headerName: 'Date of Activation',
      width: 150,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'retail_state',
      headerName: 'State',
      width: 150
    },
    {
      field: 'retail_district',
      headerName: 'District',
      width: 120,
      cellClassName: 'center-align-cell'
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          sx={{
            borderColor: '#688B2A',
            color: '#688B2A',
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#688B2A'
            }
          }}
          onClick={() => handleClick(params.row.user_id)}
          endIcon={<ForwardToInboxIcon />}
        >
          Send Email
        </Button>
      )
    }
  ];

  const handleClick = (data) => {
    setConfirmDialog(true);
    setDialogData(data);
  };
  const handleUpdate = () => {
    if (DialogData) {
      BrandEmail(DialogData, setIsLoading, setSuccess, setError, setConfirmDialog, props.refunctionwithOut);
    }
  };

  const rows =
    WithouCspBrand && Array.isArray(WithouCspBrand)
      ? WithouCspBrand.map((item) => ({
          id: item.user_id,
          bank_name: item?.csp_code_details?.bank_name || '-',
          agent_code: item?.csp_code_details?.agent_code || '-',
          agent_name: item?.csp_code_details?.agent_name || '-',
          csp_code: item.csp_code_details.csp_code || '-',
          csp_code_activation_date: item?.csp_code_activation_date || '-',
          retail_state: item?.retail_state || '-',
          retail_district: item?.retail_district || '-',
          csp_id: item?.csp_id || '-',
          user_id: item?.user_id || '-'
        }))
      : [];
  return (
    <>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Success}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
      >
        <Alert onClose={() => setSuccess(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <Dialog open={confirmDialog} onClose={() => setConfirmDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Typography variant="h3">Are you sure you want to the Email</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDialog(false)}
            sx={{
              color: '#688B2A',
              '&:hover': {
                color: '#688B2A'
              }
            }}
            color="secondary"
          >
            No
          </Button>
          <LoadingButton
            loading={IsLoading}
            onClick={handleUpdate}
            sx={{
              backgroundColor: '#688B2A',
              color: '#fff',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#688B2A'
              }
            }}
            color="secondary"
            variant="contained"
          >
            Yes
          </LoadingButton>
        </DialogActions>
      </Dialog>
      {/* {WithouCspBrand && WithouCspBrand.length > 0 ? ( */}
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
              page: 0
            }
          }
        }}
        sx={{
          '& .center-align-cell': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          },
          '& .MuiDataGrid-columnHeaders': {
            color: '#592375'
          }
        }}
        autoHeight
        pageSizeOptions={[5, 50, 100]} // Allow user to choose from these options
        rowCount={props.TotalCount}
        paginationMode="server"
        onPaginationModelChange={(paginationModel) => {
          props.setPage(paginationModel.page); // Update the current page
          props.setRowsPerPage(paginationModel.pageSize); // Update the rows per page
        }}
        getRowId={(row) => row.id}
        disableRowSelectionOnClick
      />
      {/* ) : (
              <Stack justifyContent="center" alignItems="center">
                <Typography mt={1} variant="h5">
                  No branding data found
                </Typography>
              </Stack>
            )} */}
    </>
  );
};

export default WithoutCsp;
